import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { Bookmark, Trash2, Radio } from "lucide-react";
import { api } from "@/lib/api";
import { Loading, PageHead, Empty, money } from "@/components/common";

export default function Saved() {
  const navigate = useNavigate();
  const [items, setItems] = useState(null);

  const load = () => api.get("/me/saved").then((d) => setItems(d.saved)).catch(() => setItems([]));
  useEffect(() => { load(); }, []);
  if (items === null) return <Loading />;

  const unsave = async (e, lot) => {
    e.stopPropagation();
    const prev = items;
    setItems((l) => l.filter((x) => x.id !== lot.id));
    try { await api.del(`/lots/${lot.id}/save`); }
    catch (err) { toast.error(err.message); setItems(prev); }
  };

  return (
    <div className="fade-up">
      <PageHead title="Saved" sub="Items you bookmarked to come back to." />
      {items.length === 0 ? (
        <Empty icon={Bookmark} title="Nothing saved yet" sub="Tap the bookmark on any item to save it here." />
      ) : (
        <div className="ss-grid grid-3" data-testid="saved-grid">
          {items.map((lot) => (
            <div key={lot.id} className="ss-card" style={{ overflow: "hidden", cursor: "pointer", position: "relative" }}
              onClick={() => lot.show_id && navigate(`/show/${lot.show_id}`)} data-testid={`saved-${lot.id}`}>
              <div style={{ position: "relative", aspectRatio: "4 / 3", background: "var(--surface-3)" }}>
                {lot.image ? <img src={lot.image} alt={lot.title} style={{ width: "100%", height: "100%", objectFit: "cover" }} /> : null}
                <button onClick={(e) => unsave(e, lot)} title="Remove" data-testid={`unsave-${lot.id}`}
                  style={{ position: "absolute", top: 10, right: 10, background: "rgba(0,0,0,.55)", color: "#fff", border: "none", borderRadius: 999, width: 34, height: 34, display: "grid", placeItems: "center", cursor: "pointer" }}>
                  <Trash2 size={16} />
                </button>
                {lot.status === "sold" && <span className="tag" style={{ position: "absolute", bottom: 10, left: 10, background: "var(--red)", color: "#fff" }}>Sold</span>}
              </div>
              <div style={{ padding: 14 }}>
                <div style={{ fontWeight: 800 }}>{lot.title}</div>
                <div className="ss-muted" style={{ fontSize: 13, marginTop: 2 }}>{lot.seller_name}{lot.show_title ? ` · ${lot.show_title}` : ""}</div>
                <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginTop: 8 }}>
                  <span style={{ fontWeight: 800, color: "var(--brand)" }}>{money(lot.type === "auction" ? (lot.current_bid ?? lot.price) : lot.price)}</span>
                  <span className="ss-btn ss-btn-ghost ss-btn-sm"><Radio size={13} /> View</span>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
